import { render, staticRenderFns } from "./Vulnerabilidade.vue?vue&type=template&id=30acc659"
import script from "./Vulnerabilidade.vue?vue&type=script&lang=js"
export * from "./Vulnerabilidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports